import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const ERC = ({ template }) => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <StyledImage
            src={messages[`${template}.erc.image.src`]}
            alt={messages[`${template}.erc.image.alt`]}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id={`${template}.erc.title`} />
          </Title>
          <Subtitle>
            <FormattedMessage id={`${template}.erc.paragraph`} />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

ERC.propTypes = {
  template: PropTypes.string.isRequired,
};

export default ERC;
